export default function useAbTest () {
  function getValue () {
    const abCookieHeader = useRequestHeaders(['x-dtm-ab-cookie'])['x-dtm-ab-cookie'];
    const abCookie = useState<string>('ab-cookie', () => abCookieHeader as string);
    return abCookie.value;
  }
  return {
    getValue
  };
}
